<template>
    <!-- Modal -->
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="questionModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="questionModalLabel">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{message}}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('no')">{{$t('page.modal.no')}}</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('yes')">{{$t('page.modal.yes')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            id: String,
            title: String,
            message: String,
        },
      methods: {
        show: function(){
          $('#'+this.id).modal("show");
        },
        hide: function(){
          $('#'+this.id).modal("hide");
        }
      }
    }
</script>
